var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<strong class=\"tit_comment\">댓글<span class=\"txt_num\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"commentCount") || (depth0 != null ? lookupProperty(depth0,"commentCount") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"commentCount","hash":{},"data":data,"loc":{"start":{"line":1,"column":52},"end":{"line":1,"column":70}}}) : helper)))
    + "</span></strong>\n";
},"useData":true});